import { createContext, useContext, ReactNode } from 'react';
import { useScreenSize } from '@/hooks/useScreenSize';

const ScreenSizeContext = createContext<ReturnType<typeof useScreenSize> | null>(null);

interface ScreenSizeProviderProps {
  children: ReactNode;
  mediaQueryFunc: (query: string) => boolean;
  isMobileDevice: boolean;
}

export const ScreenSizeProvider = ({ children, mediaQueryFunc, isMobileDevice }: ScreenSizeProviderProps) => {
  const screenSize = useScreenSize(mediaQueryFunc, isMobileDevice);

  return (
    <ScreenSizeContext.Provider value={screenSize}>
      {children}
    </ScreenSizeContext.Provider>
  );
};

export const useScreenSizeContext = () => {
  const context = useContext(ScreenSizeContext);
  if (!context) {
    throw new Error('useScreenSizeContext must be used within a ScreenSizeProvider');
  }
  return context;
};
